export default "__VITE_ASSET__a3af92bf__$_?component__"